import React from 'react';
import { Field } from 'react-final-form';
import Translate from 'react-translate-component';

import InputHidden from 'components/common/form/InputHidden';

const validateExist = () => <Translate content="errors.formNotSet" />;

const ValidateExistField = () => (
    <Field
        name='validateExist'
        validate={validateExist}
        component={InputHidden}
    />
);

export default ValidateExistField;
